export default function sum(a: number, b: number | boolean) {
	return a + ~~b
}

export const fullReducer = [sum, 0]
